/**
 * Face features: blush, nose, aging, mouth & glasses
 */
export function drawFaceBlush(ctx, size, options = {}) {
  const expr = options.expression || 'happy';
  const isFemale = options.gender === 'female';
  const age = options.age || 'adult';
  const isChild = age === 'child';

  // 2. Má hồng (Blush)
  if (
    options.hasBlush ||
    isFemale ||
    isChild ||
    expr === 'embarrassed' ||
    expr === 'happy' ||
    expr === 'laugh' ||
    expr === 'wink' ||
    expr === 'crying'
  ) {
    const blushOpacity = expr === 'embarrassed' ? 0.75 : expr === 'crying' ? 0.55 : 0.4;
    ctx.fillStyle = `rgba(255, 120, 150, ${blushOpacity})`;
    ctx.beginPath();
    ctx.arc(size * 0.2, size * 0.62, size * 0.1, 0, Math.PI * 2);
    ctx.arc(size * 0.8, size * 0.62, size * 0.1, 0, Math.PI * 2);
    ctx.fill();

    // Vạch chéo đỏ ngượng ngùng (Anime blush marks)
    if (expr === 'embarrassed') {
      ctx.strokeStyle = '#e11d48';
      ctx.lineWidth = 2.5;
      [-1, 1].forEach((side) => {
        const cx = side === -1 ? size * 0.2 : size * 0.8;
        for (let i = -1; i <= 1; i++) {
          ctx.beginPath();
          ctx.moveTo(cx + i * 8 - 4, size * 0.62 - 8);
          ctx.lineTo(cx + i * 8 + 4, size * 0.62 + 8);
          ctx.stroke();
        }
      });
    }
  }
}

export function drawFaceNoseAndAging(ctx, size, options = {}) {
  const expr = options.expression || 'happy';
  const isFemale = options.gender === 'female';
  const age = options.age || 'adult';
  const isChild = age === 'child';
  const isElder = age === 'elder';
  const isMature = isElder || age === 'senior';
  const eyeY = size * 0.47;
  const eyeW = size * 0.14 * (isChild ? 1.08 : 1);
  const eyeH = size * 0.18 * (isChild ? 1.1 : isElder ? 0.85 : 1);

  // 3b. Sống mũi & nếp nhăn theo tuổi
  if (!isChild) {
    ctx.fillStyle = `rgba(120, 60, 40, ${isFemale ? 0.18 : 0.3})`;
    ctx.fillRect(size * 0.47, size * 0.625, size * 0.06, size * 0.025);
  }
  if (isMature) {
    ctx.strokeStyle = `rgba(110, 60, 40, ${isElder ? 0.5 : 0.3})`;
    ctx.lineWidth = size * 0.012;
    ctx.lineCap = 'round';
    // Nếp chân chim đuôi mắt
    [
      [size * 0.19, -1],
      [size * 0.81, 1]
    ].forEach(([cx, side]) => {
      for (let i = 0; i < (isElder ? 2 : 1); i++) {
        ctx.beginPath();
        ctx.moveTo(cx, eyeY + size * (0.06 + i * 0.05));
        ctx.lineTo(cx + side * size * 0.04, eyeY + size * (0.04 + i * 0.06));
        ctx.stroke();
      }
    });
    // Rãnh cười hai bên cánh mũi
    [-1, 1].forEach((side) => {
      ctx.beginPath();
      ctx.moveTo(size * (0.5 + side * 0.13), size * 0.62);
      ctx.quadraticCurveTo(size * (0.5 + side * 0.18), size * 0.7, size * (0.5 + side * 0.15), size * 0.79);
      ctx.stroke();
    });
    if (isElder) {
      // Nếp nhăn trán & bọng mắt
      [0.31, 0.35].forEach((fy) => {
        ctx.beginPath();
        ctx.moveTo(size * 0.32, size * fy);
        ctx.quadraticCurveTo(size * 0.5, size * (fy - 0.015), size * 0.68, size * fy);
        ctx.stroke();
      });
      [size * 0.22, size * 0.64].forEach((ex) => {
        ctx.beginPath();
        ctx.moveTo(ex, eyeY + eyeH + size * 0.025);
        ctx.quadraticCurveTo(ex + eyeW / 2, eyeY + eyeH + size * 0.05, ex + eyeW, eyeY + eyeH + size * 0.025);
        ctx.stroke();
      });
    }
  }

  // 4. Nước mắt (Sad / Crying) hoặc Giọt mồ hôi (Scared / Embarrassed)
  if (expr === 'crying') {
    // Hai dòng nước mắt xối xả tuôn từ khóe mắt xuống tận cằm!
    ctx.fillStyle = '#38bdf8';
    [-1, 1].forEach((side) => {
      const streamX = side === -1 ? size * 0.24 : size * 0.68;
      const streamW = size * 0.08;
      // Vệt suối nước mắt dọc
      ctx.fillRect(streamX, eyeY + size * 0.08, streamW, size * 0.32);
      // Giọt đọng to tròn ở cuối dòng
      ctx.beginPath();
      ctx.arc(streamX + streamW / 2, eyeY + size * 0.4, streamW * 0.75, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (expr === 'sad') {
    ctx.fillStyle = '#38bdf8';
    [-1, 1].forEach((side) => {
      const tearX = side === -1 ? size * 0.26 : size * 0.74;
      ctx.beginPath();
      ctx.arc(tearX, eyeY + eyeH + size * 0.04, size * 0.03, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (expr === 'scared' || expr === 'embarrassed') {
    // Giọt mồ hôi bên thái dương
    ctx.fillStyle = '#38bdf8';
    ctx.beginPath();
    ctx.arc(size * 0.86, eyeY - size * 0.04, size * 0.032, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(size * 0.86 - size * 0.03, eyeY - size * 0.04);
    ctx.lineTo(size * 0.86, eyeY - size * 0.08);
    ctx.lineTo(size * 0.86 + size * 0.03, eyeY - size * 0.04);
    ctx.fill();
  }
}

export function drawFaceMouth(ctx, size, options = {}) {
  const expr = options.expression || 'happy';
  const isFemale = options.gender === 'female';

  // 5. Miệng theo từng biểu cảm
  ctx.fillStyle = options.mouthColor || (isFemale ? '#e11d48' : '#c0392b');
  const mouthY = size * 0.73;

  if (expr === 'neutral') {
    // Miệng trung tính ngang nhẹ thư thái phẳng lặng
    ctx.strokeStyle = '#c0392b';
    ctx.lineWidth = size * 0.028;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(size * 0.44, mouthY);
    ctx.lineTo(size * 0.56, mouthY);
    ctx.stroke();
  } else if (expr === 'talking' || expr === 'explain' || expr === 'present') {
    // Miệng đang nói chuyện / thuyết trình phát âm tự nhiên
    ctx.fillStyle = '#881337';
    ctx.beginPath();
    ctx.ellipse(size * 0.5, mouthY, size * 0.085, size * 0.065, 0, 0, Math.PI * 2);
    ctx.fill();
    // Hàm răng trên
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.44, mouthY - size * 0.055, size * 0.12, size * 0.025);
    // Lưỡi hồng bên dưới
    ctx.fillStyle = '#f43f5e';
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY + size * 0.03, size * 0.045, 0, Math.PI);
    ctx.fill();
  } else if (expr === 'yelling') {
    // Miệng gào to / la hét mở to cực đại
    ctx.fillStyle = '#881337';
    if (typeof ctx.roundRect === 'function') {
      ctx.beginPath();
      ctx.roundRect(size * 0.35, mouthY - size * 0.08, size * 0.3, size * 0.16, [6, 6, 16, 16]);
      ctx.fill();
    } else {
      ctx.fillRect(size * 0.35, mouthY - size * 0.08, size * 0.3, size * 0.16);
    }
    // Hàm răng trên trắng sắc nét
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.37, mouthY - size * 0.075, size * 0.26, size * 0.035);
    // Lưỡi rung đỏ thẫm
    ctx.fillStyle = '#ef4444';
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY + size * 0.04, size * 0.075, 0, Math.PI);
    ctx.fill();
  } else if (expr === 'crying') {
    // Miệng mếu máo chữ V ngược cong xuống
    ctx.strokeStyle = '#c0392b';
    ctx.lineWidth = size * 0.04;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY + size * 0.09, size * 0.1, Math.PI * 1.15, Math.PI * 1.85);
    ctx.stroke();
  } else if (expr === 'happy' || expr === 'greet' || expr === 'thank_you') {
    // Nụ cười tươi
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY - size * 0.02, size * 0.1, 0, Math.PI);
    ctx.fill();
  } else if (expr === 'laugh') {
    // Cười ngoác miệng thấy răng và lưỡi
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY - size * 0.03, size * 0.13, 0, Math.PI);
    ctx.fill();
    // Hàm răng trên trắng
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.4, mouthY - size * 0.03, size * 0.2, size * 0.04);
  } else if (expr === 'surprise') {
    // Miệng há hốc tròn chữ O lớn
    ctx.beginPath();
    ctx.ellipse(size * 0.5, mouthY, size * 0.08, size * 0.1, 0, 0, Math.PI * 2);
    ctx.fill();
  } else if (expr === 'sad') {
    // Khóe miệng trễ xuống
    ctx.strokeStyle = '#c0392b';
    ctx.lineWidth = size * 0.035;
    ctx.beginPath();
    ctx.arc(size * 0.5, mouthY + size * 0.07, size * 0.08, Math.PI * 1.15, Math.PI * 1.85);
    ctx.stroke();
  } else if (expr === 'angry') {
    // Miệng nghiến răng tức giận
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.38, mouthY - size * 0.03, size * 0.24, size * 0.07);
    ctx.strokeStyle = '#1e293b';
    ctx.lineWidth = 2.5;
    ctx.strokeRect(size * 0.38, mouthY - size * 0.03, size * 0.24, size * 0.07);
    for (let i = 1; i <= 3; i++) {
      ctx.beginPath();
      ctx.moveTo(size * 0.38 + i * (size * 0.06), mouthY - size * 0.03);
      ctx.lineTo(size * 0.38 + i * (size * 0.06), mouthY + size * 0.04);
      ctx.stroke();
    }
  } else if (expr === 'scared' || expr === 'dizzy') {
    // Miệng lượn sóng méo xệch
    ctx.strokeStyle = '#c0392b';
    ctx.lineWidth = size * 0.035;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(size * 0.38, mouthY);
    ctx.quadraticCurveTo(size * 0.44, mouthY - size * 0.04, size * 0.5, mouthY);
    ctx.quadraticCurveTo(size * 0.56, mouthY + size * 0.04, size * 0.62, mouthY);
    ctx.stroke();
  } else if (expr === 'think') {
    // Miệng thẳng ngang
    ctx.fillRect(size * 0.44, mouthY, size * 0.14, size * 0.035);
  } else if (expr === 'embarrassed') {
    // Miệng cười gượng nhẹ
    ctx.strokeStyle = '#c0392b';
    ctx.lineWidth = size * 0.03;
    ctx.beginPath();
    ctx.moveTo(size * 0.42, mouthY + size * 0.01);
    ctx.quadraticCurveTo(size * 0.5, mouthY - size * 0.02, size * 0.58, mouthY + size * 0.01);
    ctx.stroke();
  } else if (expr === 'wink') {
    // Miệng cười mỉm lệch duyên dáng
    ctx.beginPath();
    ctx.arc(size * 0.52, mouthY - size * 0.02, size * 0.08, 0, Math.PI * 0.85);
    ctx.fill();
  }
}

export function drawFaceGlasses(ctx, size, options = {}) {
  // 6. Kính mắt tích hợp texture (nếu không dùng kính 3D)
  if (options.hasGlasses) {
    const age = options.age || 'adult';
    const isChild = age === 'child';
    const isElder = age === 'elder';
    const eyeY = size * 0.47;
    const eyeW = size * 0.14 * (isChild ? 1.08 : 1);
    const eyeH = size * 0.18 * (isChild ? 1.1 : isElder ? 0.85 : 1);

    ctx.strokeStyle = '#1e293b';
    ctx.lineWidth = size * 0.03;
    ctx.strokeRect(size * 0.16, eyeY - size * 0.04, eyeW + size * 0.1, eyeH + size * 0.08);
    ctx.strokeRect(size * 0.58, eyeY - size * 0.04, eyeW + size * 0.1, eyeH + size * 0.08);
    ctx.beginPath();
    ctx.moveTo(size * 0.4, eyeY + size * 0.05);
    ctx.lineTo(size * 0.58, eyeY + size * 0.05);
    ctx.stroke();
  }
}
